

import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faTools, 
  faTimes,
  faCheckCircle,
  faBolt,
  faLayerGroup,
  faRulerCombined,
  faClipboardCheck,
  faPlay,
  faStar,
  faShield,
  faBuilding
} from "@fortawesome/free-solid-svg-icons";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { motion, AnimatePresence } from "framer-motion";
import "./theme.css";

import vid6 from '../../Assesst/vid6.mp4';
import thm6 from '../../Assesst/629992239_17898564786381730_7476464499665088684_n.jpg';
import vid7 from '../../Assesst/vid7.mp4';
import thm7 from '../../Assesst/633802276_17899525947381730_5262136853547666250_n.jpg';
import vid8 from '../../Assesst/vid8.mp4';
import thm8 from '../../Assesst/Image-459.jpg';
import vid9 from '../../Assesst/vid9.mp4';
import thm9 from '../../Assesst/631467316_17899644711381730_1228051924609546819_n.jpg';
import thm10 from "../../Assesst/vid1.mp4";
import thm11 from "../../Assesst/thms8.png";
import thm12 from "../../Assesst/Laminancevsodinary.jpeg";
import vid10 from '../../Assesst/Ordinary plywood vs Laminance Cabinets.mp4';
import showroom from '../../Assesst/vid3.mp4';
import showroomthm from '../../Assesst/Image-121.jpg';
 

gsap.registerPlugin(ScrollTrigger);

const ServicesSection = () => {
  const navigate = useNavigate();
  const { serviceVideoId } = useParams();
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);
  const [activeVideo, setActiveVideo] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const services = [
    {
  id: "laminance-cabinetry-ordinary-plywood-Vs-laminance-cabinet",
  icon: faShield,
  title: " Laminance Cabinet Vs Ordinary Plywood ",
  shortTitle: "Laminance Vs Ordinary Plywood",
  description: "See the difference between ordinary plywood and Laminance premium cabinets. Designed with superior materials, glossy finishes, and built to resist moisture for long-lasting performance.",
  longDescription: "Not all materials are created equal. Ordinary plywood can absorb moisture, swell, and deteriorate over time. Laminance Cabinets are crafted using premium materials and advanced technology to provide moisture resistance, durability, and beautiful glossy finishes that keep your kitchen looking premium for years.",
  videoUrl: vid10,
  videoType: "video/mp4",
  features: [
    "Moisture Resistant Protection",
    "Easy to Clean & Maintain",
    "Built to Last for Years",
  ],

  gradient: "var(--color-primary-500)",

  thumbnail: thm12,

  keywords: "ordinary plywood vs laminance cabinets, premium kitchen cabinets, moisture resistant cabinets, glossy kitchen cabinets, custom cabinets, Laminance Cabinetry",

  category: "Cabinet Quality"
},
    {
      id: "laminance-cabinetry-new-cabinet-style",
      icon: faStar,
      title: "New Cabinet Style - Laminance Cabinetry",
      shortTitle: "New Cabinet Style",
      description: "Transform your kitchen with our premium cabinet styles including Shaker, Petite, and Raised Center designs. Over 290+ colors to match your unique vision.",
      longDescription: "Discover our extensive collection of cabinet styles featuring modern, traditional, and contemporary designs. Each cabinet is crafted with precision and available in over 290 colors to perfectly complement your kitchen aesthetic.",
      videoUrl: thm10,
      videoType: "video/mp4",
      features: ["Transform Your Space", "Shaker • Petite • Raised Center Styles", "Variety of cabinets for every taste", "290+ colors to match your vision"],
      gradient: "var(--color-primary-500)",
      thumbnail: thm11,
      keywords: "custom kitchen cabinets, cabinet styles, shaker cabinets, modern cabinets, kitchen transformation, Laminance Cabinetry",
      category: "Cabinet Styles"
    },
    {
      id: "laminance-cabinetry-all-inclusive-service",
      icon: faClipboardCheck,
      title: "All Inclusive Kitchen Service - Laminance Cabinetry",
      shortTitle: "All Inclusive Service",
      description: "Complete kitchen renovation with end-to-end project management. No hidden costs, quality guaranteed from start to finish.",
      longDescription: "Our all-inclusive kitchen service covers everything from initial design consultation to final installation. Experience stress-free kitchen renovation with single-point project management and guaranteed quality.",
      videoUrl: vid9,
      videoType: "video/mp4",
      features: ["Complete Project Management", "No Hidden Costs", "End-to-End Solution", "Quality Assurance"],
      gradient: "var(--color-primary-500)",
      thumbnail: thm9,
      keywords: "kitchen renovation, all-inclusive kitchen, project management, kitchen installation, stress-free renovation, Laminance Cabinetry",
      category: "Kitchen Services"
    },
    {
      id: "laminance-cabinetry-premium-materials",
      icon: faLayerGroup,
      title: "Premium Cabinet Materials - Laminance Cabinetry",
      shortTitle: "Premium Materials",
      description: "High-grade materials with durable finishes and eco-friendly options. Industry best quality guaranteed.",
      longDescription: "We use only the highest quality materials for your kitchen cabinets. Our premium finishes are durable, eco-friendly, and designed to last for years. Choose from a wide range of sustainable options.",
      videoUrl: vid8,
      videoType: "video/mp4",
      features: ["High-Grade Materials", "Durable Finishes", "Eco-Friendly Options", "Industry Best Quality"],
      gradient: "var(--color-primary-500)",
      thumbnail: thm8,
      keywords: "premium cabinet materials, durable finishes, eco-friendly cabinets, high-quality kitchen cabinets, Laminance Cabinetry",
      category: "Materials"
    },
    {
      id: "laminance-cabinetry-full-custom-design",
      icon: faRulerCombined,
      title: "Full Custom Design - Laminance Cabinetry",
      shortTitle: "Full Custom Design",
      description: "Tailored designs with 3D visualization and personalized planning. Create your dream kitchen with flexible options.",
      longDescription: "Our custom design service brings your vision to life with professional 3D visualization and personalized planning. Every element is tailored to your specific needs and preferences.",
      videoUrl: vid7,
      videoType: "video/mp4",
      features: ["Tailored Designs", "3D Visualization", "Personalized Planning", "Flexible Options"],
      gradient: "var(--color-primary-500)",
      thumbnail: thm7,
      keywords: "custom kitchen design, 3D kitchen visualization, personalized cabinets, dream kitchen design, Laminance Cabinetry",
      category: "Design"
    },
    {
      id: "laminance-cabinetry-problem-solution",
      icon: faBolt,
      title: "Problem & Solution Experts - Laminance Cabinetry",
      shortTitle: "Problem & Solution",
      description: "All materials and labor in one place. Optimized space with fully custom solutions. Remove coordination stress with multiple suppliers.",
      longDescription: "We eliminate the hassle of coordinating multiple contractors. Our comprehensive solution includes all materials, labor, and project management. Get unbeatable prices with guaranteed quality.",
      videoUrl: vid6,
      videoType: "video/mp4",
      features: [
        "All materials and Labor in one place", 
        "Optimized space - everything is fully custom", 
        "We remove coordination stress with multiple suppliers", 
        "Unbeatable price - Guaranteed!"
      ],
      gradient: "var(--color-primary-500)",
      thumbnail: thm6,
      keywords: "kitchen problem solving, custom kitchen solutions, project coordination, stress-free renovation, Laminance Cabinetry",
      category: "Solutions"
    },
    {
  id: "laminance-cabinetry-showroom-newjersey",
  icon: faBuilding, // or FaStore, FaHome, etc.
  title: "Laminance Cabinetry Showroom - New Jersey",
  shortTitle: "Laminance Showroom",
  description: "Visit our New Jersey showroom to explore our premium collection of European style kitchens, Indian style kitchens, and custom cabinetry solutions.",
  longDescription: "Experience the Laminance difference at our New Jersey showroom. Explore our diverse range of kitchen styles including sleek European designs with handle-less finishes and warm, functional Indian style kitchens with traditional elements. Our experts will help you find the perfect cabinetry solution for your home.",
  videoUrl: showroom,
  videoType: "video/mp4",
  features: [
    "European style kitchen collection",
    "Indian style kitchen designs", 
    "Custom cabinetry solutions",
    "Expert design consultation",
    "Hands-on product experience"
  ],
  gradient: "var(--color-primary-500)",
  thumbnail: showroomthm,
  keywords: "Laminance Cabinetry showroom, New Jersey kitchen showroom, European style kitchen, Indian style kitchen, custom cabinets NJ",
  category: "Showroom"
},
  ];

  const addToCardsRef = (el) => {
    if (el && !cardsRef.current.includes(el)) {
      cardsRef.current.push(el);
    }
  };

  const handleVideoClick = (service, index, e) => {
    e.stopPropagation();
    setActiveVideo({ url: service.videoUrl, index, service });
    // Update URL to shareable format
    window.history.pushState({}, '', `/services/video/${service.id}`);
  };

  const handleCloseFullscreen = () => {
    setActiveVideo(null);
    // Restore original URL
    window.history.pushState({}, '', '/');
  };

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const getGradientStyle = (gradientClass) => {
    return { background: gradientClass };
  };

  // Handle direct URL access to specific service video
  useEffect(() => {
    if (serviceVideoId) {
      const service = services.find(s => s.id === serviceVideoId);
      if (service) {
        setTimeout(() => {
          setActiveVideo({ 
            url: service.videoUrl, 
            index: services.findIndex(s => s.id === serviceVideoId), 
            service 
          });
        }, 500);
      }
    }
  }, [serviceVideoId]);

  // Handle browser back button
  useEffect(() => {
    const handlePopState = () => {
      if (activeVideo) {
        handleCloseFullscreen();
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [activeVideo]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      cardsRef.current.forEach((card, index) => {
        gsap.fromTo(card,
          {
            y: 100,
            opacity: 0,
            scale: 0.8
          },
          {
            y: 0,
            opacity: 1,
            scale: 1,
            duration: 0.8,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 80%",
              end: "bottom 20%",
              toggleActions: "play none none reverse"
            },
            delay: index * 0.1
          }
        );
      });

      gsap.fromTo(".services-title", 
        {
          y: 50,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: ".services-title",
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  // Schema for services
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Kitchen Cabinet and Renovation Services",
    "description": "Professional kitchen cabinet installation and complete kitchen renovation services in New Jersey. Custom designs, premium materials, and all-inclusive packages.",
    "provider": {
      "@type": "Organization",
      "name": "Laminance Cabinetry",
      "url": "https://laminance.com"
    },
    "areaServed": {
      "@type": "State",
      "name": "New Jersey"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Kitchen Services",
      "itemListElement": services.map((service, index) => ({
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": service.title,
          "description": service.description
        },
        "position": index + 1
      }))
    }
  };

  const videoSchemas = services.map((service) => ({
  "@context": "https://schema.org",
  "@type": "VideoObject",

  "name": service.title,

  "description": service.description,

  "thumbnailUrl": service.thumbnail,

  "contentUrl": service.videoUrl,

  "embedUrl": `https://laminance.com/services/video/${service.id}`,

  // Full ISO date + timezone
  "uploadDate": "2025-01-01T10:00:00-05:00",

  "duration": "PT2M",

  "keywords": Array.isArray(service.keywords)
    ? service.keywords.join(", ")
    : service.keywords,

  "publisher": {
    "@type": "Organization",

    "name": "Laminance Cabinetry",

    "logo": {
      "@type": "ImageObject",
      "url": "https://laminance.com/assets/Images/logo.png"
    }
  },

  "provider": {
    "@type": "Organization",

    "name": "Laminance Cabinetry",

    "sameAs": "https://laminance.com"
  },

  "potentialAction": {
    "@type": "WatchAction",
    "target": `https://laminance.com/services/video/${service.id}`
  }
}));

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "name": "Laminance Cabinetry",
    "description": "Premier custom kitchen cabinet and complete kitchen renovation services in New Jersey. Specializing in custom designs, premium materials, and all-inclusive kitchen packages.",
    "url": "https://laminance.com",
    "telephone": "+18624506069",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "418 Rt 23",
      "addressLocality": "Franklin",
      "addressRegion": "NJ",
      "postalCode": "07416",
      "addressCountry": "US"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://laminance.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Kitchen Services",
        "item": "https://laminance.com/services"
      }
    ]
  };

  return (
    <>
      <Helmet>
        <title>Professional Kitchen Cabinet Services | Custom Design & Installation | Laminance Cabinetry</title>
        <meta name="title" content="Professional Kitchen Cabinet Services | Custom Design & Installation | Laminance Cabinetry" />
        <meta name="description" content="Professional kitchen cabinet services including custom design, premium materials, all-inclusive renovation, and expert installation in New Jersey. Free consultation available! Watch our service videos." />
        <meta name="keywords" content="kitchen cabinet services, custom kitchen design, cabinet installation, kitchen renovation, premium cabinets, Laminance Cabinetry, New Jersey" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://laminance.com/services" />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://laminance.com/services" />
        <meta property="og:title" content="Professional Kitchen Cabinet Services | Laminance Cabinetry" />
        <meta property="og:description" content="Professional kitchen cabinet services including custom design, premium materials, and complete renovation in New Jersey." />
        <meta property="og:image" content={thm6} />
        <meta property="og:image:alt" content="Laminance Cabinetry professional kitchen cabinet services showcase" />
        <meta property="og:site_name" content="Laminance Cabinetry" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://laminance.com/services" />
        <meta name="twitter:title" content="Professional Kitchen Cabinet Services | Laminance Cabinetry" />
        <meta name="twitter:description" content="Professional kitchen cabinet services including custom design, premium materials, and complete renovation in New Jersey." />
        <meta name="twitter:image" content={thm6} />
        <meta name="twitter:site" content="@laminance" />
        
        {/* Geo Meta Tags */}
        <meta name="geo.region" content="US-NJ" />
        <meta name="geo.placename" content="Franklin" />
        <meta name="geo.position" content="41.1220;-74.5804" />
        
        {/* Structured Data */}
        <script type="application/ld+json">{JSON.stringify(serviceSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        {videoSchemas.map((schema, index) => (
          <script key={index} type="application/ld+json">{JSON.stringify(schema)}</script>
        ))}
      </Helmet>

      <section
        ref={sectionRef}
        className="py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden"
        aria-labelledby="services-heading"
        style={{
          background: "var(--gradient-bg)",
        }}
      >
        {/* Hidden SEO Image */}
        <img 
          src={thm6}
          alt="Laminance Cabinetry professional kitchen cabinet services in New Jersey"
          className="hidden"
          loading="eager"
          fetchPriority="high"
          width="1920"
          height="1080"
        />

        {/* Background Decorations */}
        <div 
          className="absolute top-0 left-0 w-72 h-72 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-40"
          style={{ backgroundColor: "var(--color-primary-100)" }}
          aria-hidden="true"
        ></div>
        <div 
          className="absolute bottom-0 right-0 w-96 h-96 rounded-full translate-x-1/3 translate-y-1/3 opacity-60"
          style={{ backgroundColor: "var(--color-secondary-50)" }}
          aria-hidden="true"
        ></div>
        
        <div className="max-w-7xl mx-auto relative z-10">
          {/* Section Header */}
          <header className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6 mx-auto"
              style={{
                background: "var(--bg-primary-10)",
                border: "1px solid var(--border-primary-20)",
              }}
            >
              <FontAwesomeIcon icon={faTools} size="sm" style={{ color: "var(--color-primary-400)" }} />
              <span className="text-sm font-medium" style={{ color: "var(--color-primary-400)" }}>
                Professional Services
              </span>
            </div>
            
            <h1
              id="services-heading"
              className="bell-mt-primary services-title text-4xl sm:text-5xl md:text-6xl font-bold mb-6"
              style={{
                background: "var(--gradient-primary)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              Why Choose Laminance Cabinetry?
            </h1>
            
            <motion.p 
              className="inter-secondary text-base sm:text-lg md:text-xl max-w-3xl mx-auto leading-relaxed"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              style={{ color: "var(--color-gray-600)" }}
            >
              Experience unparalleled quality and service with our comprehensive kitchen solutions. 
              From custom design to professional installation, we handle every aspect of your kitchen transformation.
            </motion.p>
            
            <div className="flex justify-center mt-6" aria-hidden="true">
              <div 
                className="w-24 h-1 rounded-full"
                style={{ background: "var(--gradient-primary)" }}
              ></div>
            </div>
          </header>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6" role="list">
            {services.map((service, index) => (
              <motion.article
                key={service.id}
                ref={addToCardsRef}
                className="group relative rounded-2xl hover:shadow-2xl transition-all duration-500 overflow-hidden cursor-pointer"
                whileHover={{ y: -5, scale: 1.02 }}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
                onClick={(e) => handleVideoClick(service, index, e)}
                role="listitem"
                aria-labelledby={`service-${service.id}-title`}
                style={{
                  backgroundColor: "var(--color-white)",
                  boxShadow: "var(--shadow-medium)",
                  border: "1px solid var(--border-light)",
                }}
              >
                <div className="relative">
                  {/* Video Container */}
                  <div className="relative w-full aspect-video bg-gray-900 overflow-hidden">
                    <img
                      src={service.thumbnail}
                      alt={`${service.title} - professional kitchen service by Laminance Cabinetry in New Jersey`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                      width="400"
                      height="225"
                      decoding="async"
                    />

                    {/* Hover Overlay with Play Button */}
                    <motion.div 
                      className="absolute inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: hoveredIndex === index ? 1 : 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <motion.div
                        className="w-14 h-14 rounded-full flex items-center justify-center shadow-xl border-4 border-white/80"
                        style={{ background: "var(--gradient-primary)" }}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        onClick={(e) => handleVideoClick(service, index, e)}
                      >
                        <FontAwesomeIcon
                          icon={faPlay}
                          style={{
                            color: "var(--color-white)",
                            fontSize: "1.25rem",
                            marginLeft: "4px"
                          }}
                        />
                      </motion.div>
                    </motion.div>

                    {/* Category Badge */}
                    <div className="absolute top-3 left-3">
                      <span className="text-xs font-semibold px-2 py-1 rounded-full backdrop-blur-sm bg-black/50 text-white">
                        {service.category}
                      </span>
                    </div>
                  </div>

                  {/* Content Section */}
                  <div className="p-5">
                    {/* Icon */}
                    <motion.div 
                      className="relative inline-flex items-center justify-center w-12 h-12 rounded-xl mb-3 -mt-9 border-4 border-white shadow-lg"
                      style={{ background: "var(--gradient-primary)" }}
                    >
                      <FontAwesomeIcon
                        icon={service.icon}
                        style={{
                          color: "var(--color-white)",
                          fontSize: "1.25rem",
                        }}
                      />
                    </motion.div>

                    {/* Title */}
                    <h2
                      id={`service-${service.id}-title`}
                      className="bell-mt-primary text-lg font-bold mb-2 line-clamp-1"
                      style={{ color: "var(--color-primary-500)" }}
                    >
                      {service.shortTitle}
                    </h2>

                    {/* Description */}
                    <p className="inter-secondary text-xs mb-3 line-clamp-2" style={{ color: "var(--color-gray-600)" }}>
                      {service.description}
                    </p>

                    {/* Features List */}
                    <div className="space-y-1.5">
                      {service.features.slice(0, 3).map((feature, featureIndex) => (
                        <motion.div
                          key={featureIndex}
                          className="flex items-start gap-1.5"
                          initial={{ opacity: 0, x: -10 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          transition={{ delay: featureIndex * 0.1 + 0.3 }}
                        >
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            style={{
                              color: "var(--color-primary-500)",
                              fontSize: "0.625rem",
                              marginTop: "0.125rem",
                            }}
                            className="flex-shrink-0"
                          />
                          <span className="inter-secondary text-xs leading-tight" style={{ color: "var(--color-gray-600)" }}>
                            {feature}
                          </span>
                        </motion.div>
                      ))}
                    </div>
                  </div>
                </div>
              </motion.article>
            ))}
          </div>

          {/* SEO Content Section */}
          <div className="mt-16 text-center">
            <div className="max-w-4xl mx-auto">
              <h2 className="bell-mt-primary text-2xl md:text-3xl font-bold mb-4" style={{ color: "var(--color-primary-500)" }}>
                Comprehensive Kitchen Services in New Jersey
              </h2>
              <p className="inter-secondary text-base md:text-lg mb-6" style={{ color: "var(--color-gray-600)" }}>
                At Laminance Cabinetry, we provide end-to-end kitchen solutions including custom cabinet design, 
                premium material selection, professional installation, and complete project management. 
                Our all-inclusive packages ensure a stress-free renovation experience with guaranteed quality.
              </p>
              <div className="flex flex-wrap justify-center gap-3">
                <span className="inter-secondary text-sm px-3 py-1 rounded-full" style={{ backgroundColor: "var(--bg-primary-10)", color: "var(--color-primary-600)" }}>
                  Custom Cabinet Design
                </span>
                <span className="inter-secondary text-sm px-3 py-1 rounded-full" style={{ backgroundColor: "var(--bg-primary-10)", color: "var(--color-primary-600)" }}>
                  Kitchen Installation
                </span>
                <span className="inter-secondary text-sm px-3 py-1 rounded-full" style={{ backgroundColor: "var(--bg-primary-10)", color: "var(--color-primary-600)" }}>
                  Premium Materials
                </span>
                <span className="inter-secondary text-sm px-3 py-1 rounded-full" style={{ backgroundColor: "var(--bg-primary-10)", color: "var(--color-primary-600)" }}>
                  Project Management
                </span>
                <span className="inter-secondary text-sm px-3 py-1 rounded-full" style={{ backgroundColor: "var(--bg-primary-10)", color: "var(--color-primary-600)" }}>
                  Free Consultation
                </span>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="text-center mt-12">
            <motion.button
              onClick={() => navigate('/contact#contact-form')}
              className="px-8 py-3 rounded-full font-semibold text-white shadow-lg hover:shadow-xl transition-all duration-300"
              style={{ background: "var(--gradient-primary)" }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              aria-label="Schedule free kitchen consultation"
            >
              Schedule Free Consultation
            </motion.button>
          </div>

          {/* SEO Footer Keywords */}
          <div className="mt-12 text-center">
            <p className="inter-secondary text-xs opacity-60" style={{ color: "var(--color-gray-500)" }}>
              <strong>Related Services:</strong> New Cabinet Style | All Inclusive Kitchen Service | Premium Cabinet Materials | Full Custom Design | Problem & Solution Experts | Laminance Cabinetry New Jersey
            </p>
          </div>
        </div>
      </section>

      {/* Full Screen Video Modal */}
      <AnimatePresence>
        {activeVideo && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleCloseFullscreen}
          >
            <motion.div
              className="relative w-full max-w-5xl bg-black rounded-2xl overflow-hidden"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ type: "spring", damping: 25 }}
              onClick={(e) => e.stopPropagation()}
              style={{ aspectRatio: "16/9" }}
            >
              {/* Close Button */}
              <motion.button
                className="absolute top-4 right-4 z-20 w-10 h-10 rounded-full flex items-center justify-center bg-black/60 backdrop-blur-sm hover:bg-black/80 transition-colors border border-white/20"
                onClick={handleCloseFullscreen}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                aria-label="Close video"
              >
                <FontAwesomeIcon 
                  icon={faTimes} 
                  style={{ color: "var(--color-white)", fontSize: "1rem" }}
                />
              </motion.button>

              {/* Video Title Bar */}
              <div className="absolute top-0 left-0 right-0 bg-gradient-to-b from-black/70 to-transparent p-4 z-10">
                <h3 className="text-white text-lg font-semibold">{activeVideo.service?.title || "Laminance Cabinetry Service"}</h3>
              </div>

              {/* Video Player */}
              <div className="relative w-full h-full bg-black">
                <video
                  className="w-full h-full object-contain"
                  controls
                  autoPlay
                  playsInline
                  poster={activeVideo.service?.thumbnail}
                  aria-label={`Video showcasing ${activeVideo.service?.title || "Laminance Cabinetry service"}`}
                  title={activeVideo.service?.title}
                >
                  <source 
                    src={activeVideo.url} 
                    type={services.find(s => s.videoUrl === activeVideo.url)?.videoType || "video/mp4"} 
                  />
                  Your browser does not support the video tag. Watch our service video at Laminance Cabinetry.
                </video>
              </div>

              {/* Share URL Indicator */}
              
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ServicesSection;